
import {defineComponent} from "vue";
import Api from "@/common/favorites"
import {createErrorChain} from "@/services/ErrorHandler";
import ResponseType from '@/types/IResponse';

export default defineComponent({
  name: 'LikeButtonComponent',
  props: {
    mod_id: {
      type: Number,
      required: true
    }
  },
  emits: ['likeMod'],
  methods: {
     likeAction(event: any) {
      this.likeAnimation(event)

       Api.addToFavorite({
         mod_id: this.mod_id,
       }, (res: ResponseType) => {
         this.$toastr.success(res.message)
         this.$emit('likeMod')
       }, (err: any) => {
         if(err.message === 'token_error') {
           this.$toastr.error('Войдите в аккаунт, чтобы оценивать моды!')
         } else {
           const properties = [
             'mod_id', 'user_id'
           ]

           const errorHandler = createErrorChain(properties, (msg: string[]) => {
             this.$toastr.error(msg.pop())
           })

           errorHandler.handle(err)
         }
       })
    },
    likeAnimation(event: any) {
      const btn = event.target as HTMLButtonElement

      btn.classList.add('animate')

      setTimeout(() => {
        btn.classList.remove('animate')
      }, 600)
    }
  }
})
